<div class="canal-midia-social-select dropdown"
    [class.invalid]="!config.isValid">
    <button class="btn btn-light dropdown-toggle" #dropdownToggle type="button" data-toggle="dropdown" aria-expanded="false"
        [disabled]="disabled">
        <ng-template [ngIf]="canalMidiaSocial">
            <span>
                <i class="{{canalMidiaSocial.icon}}"></i>
                {{canalMidiaSocial.nome}}
            </span>
        </ng-template>

        <ng-template [ngIf]="!canalMidiaSocial">
            <span>
                Nenhum Canal
            </span>
        </ng-template>        
    </button>
    
    <div class="dropdown-menu-container">
        <div class="dropdown-menu">
            <div class="dropdown-menu-itens">
                <a class="dropdown-item" 
                    [class.dropdown-item-select]="!idCanalMidiaSocial"
                    (click)="select(null)">
                    Nenhum Canal
                </a>
                <a *ngFor="let item of canaisOptions" 
                    class="dropdown-item"
                    [class.dropdown-item-select]="item.id == idCanalMidiaSocial"
                    (click)="select(item)">
                    <i class="{{item.icon}}"></i>
                    {{item.nome}}
                </a>
            </div>
        </div>        
    </div>
</div>